$(document).ready(function () {

	$(window).scroll(function () {
		if ($(window).scrollTop() > 500) {
			$("#back-to-top").fadeIn(200);
		} else {
			$("#back-to-top").fadeOut(200);
		}
	});

	$('#back-to-top').on("click", function () {
		$('html, body').animate({ scrollTop: 0 }, '800');
		return false;
	});

	$(function () {
		$('[data-toggle="tooltip"]').tooltip();
	})
});


function showImageModal(img) {
	var modal = document.getElementById("myModal");
	var modalImg = document.getElementById("img01");
	console.log(img.src);
	modal.style.display = "block";
	modalImg.src = img.src;
	var span = document.getElementsByClassName("close")[0];
	span.onclick = function () {
		modal.style.display = "none";
	}
}

function heartClicked(id) {
	if ($("#heart").hasClass("liked")) {
		$("#heart").html('<i class="far fa-heart heart" aria-hidden="true"></i>');
		$("#heart").removeClass("liked");
	} else {
		$("#heart").html('<i class="fas fa-heart heart" aria-hidden="true"></i>');
		$("#heart").addClass("liked");
	}
}

//WOW Themes//
$(window).load(function() {
	// The slider being synced must be initialized first
	$('#carousel').flexslider({
	  animation: "slide",
	  controlNav: false,
	  animationLoop: false,
	  slideshow: false,
	  itemWidth: 210,
	  itemMargin: 5,
	  asNavFor: '#slider'
	});
   
	$('#slider').flexslider({
	  animation: "slide",
	  controlNav: false,
	  animationLoop: false,
	  slideshow: false,
	  sync: "#carousel"
	});
  });

  $(document).ready(function(){
	$('ul.nav li.dropdown').hover(function() {
		$(this).find('.dropdown-menu').stop(true, true).delay(200).fadeIn(500);
	  }, function() {
		$(this).find('.dropdown-menu').stop(true, true).delay(200).fadeOut(500);
	  });
	
}); 

$('.navbar-collapse a').click(function(){
    $(".navbar-collapse").collapse('hide');
});


$(document).ready(function(){
	// Add minus icon for collapse element which is open by default
	$(".collapse.show").each(function(){
		$(this).prev(".card-header").find(".fa").addClass("fa-minus").removeClass("fa-plus");
	});
	
	// Toggle plus minus icon on show hide of collapse element
	$(".collapse").on('show.bs.collapse', function(){
		$(this).prev(".card-header").find(".fa").removeClass("fa-plus").addClass("fa-minus");
	}).on('hide.bs.collapse', function(){
		$(this).prev(".card-header").find(".fa").removeClass("fa-minus").addClass("fa-plus");
	});
});

$(document).ready(function() {

	// Gets the video src from the data-src on each button
	
	var $videoSrc;  
	$('.video-btn').click(function() {
		$videoSrc = $(this).data( "src" );
	});
	console.log($videoSrc);});

	$(window).scroll(function () {
		if ($(this).scrollTop() > 100) {
			$('.btn-scroll-up').addClass('display').fadeIn();
		} else {
			$('.btn-scroll-up').removeClass('display').fadeOut();
		}
	});

	
	  